import React from "react";
import { Link } from "react-router-dom";
import LeadingText from "../LeadingText";

export default function HitsCount({ count }) {
  const isPlural = parseInt(count, 10) > 1;
  const text = `${count} ${isPlural ? "Ergebnisse" : "Ergebnis"} anzeigen`;
  return (
    <div className="w-full flex items-center justify-around">
      <Link to="/article">
        <LeadingText textColor="white" textSize="base">
          {text}
        </LeadingText>
      </Link>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/HitsCount/HitsCount.js